import { render } from "./ReceiversAutocompleteSuggestionsFooter.vue?vue&type=template&id=14dc16d4"
const script = {}

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__